import styles from "./Orders.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import {
  DispatchReloadIcon,
  CreateVoucherIcon,
} from "../../components/icons/Icon";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import Button from "../../components/updatedComponents/Dealers/Button";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import fetchData from "../../APIsControll/apiControll";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import ToggleSearchBar from "../../components/updatedComponents/FormComponents/ToggleSearchBar";
import VoucherList from "./VoucherList";
import OrderFilters from "./OrderFilters";
import { socket, SocketConnected } from "../../Socket/socket";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import { useDispatch, useSelector } from "react-redux";
import {
  setData,
  setFilter,
  setPagination,
  setUi,
} from "../../store/slices/order/OrderSlice";
import {
  adjustmentOrderHeader,
  daysData,
  MeOptions,
  orderHeader,
  orderTypeData,
  productionAndSaleHeader,
  purchaseOrderHeader,
  transferOrderHeader,
  yearData,
} from "../../constants/constants";
import useTableHeight from "../../hooks/useTableHeight";
import useDebounce from "../../hooks/useDebounce";

const AllOrders = () => {
  const { mode, managerId, designations, designation } = useAuth();

  const { filter, pagination, ui, data } = useSelector((r) => r.order);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const tableRef = useRef(null);

  const limit = useTableHeight(tableRef);

  const debouncedKeyword = useDebounce(filter.keyword, 700);

  const [ordersFilters, setOrdersFilters] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [purchaseFilters, setPurchaseFilters] = useState([]);
  const [adjustmentOrderData, setAdjustmentOrderData] = useState([]);
  const [adjustmentFilters, setAdjustmentFilters] = useState([]);
  const [transferOrderData, setTransferOrderData] = useState([]);
  const [transferFilters, setTransferFilters] = useState([]);
  const [reFetch, setReFetch] = useState(false);
  const [productionAndSaleOrderData, setProductionAndSaleOrderData] = useState(
    [],
  );

  const [productionAndSaleFilters, setProductionAndSaleFilters] = useState([]);

  const getSaleOrders = useCallback(
    async (id) => {
      setPurchaseOrderData([]);
      setAdjustmentOrderData([]);
      setTransferOrderData([]);

      const ordermanagerId = id ? id : filter.selectedManagerID;

      if (
        filter.orderdDaysTab === "period" &&
        (filter.orderStartDate === "" || filter.orderEndDate === "")
      )
        return;

      const apiData = {
        managerId: parseInt(managerId),
        day: filter.orderdDaysTab === "period" ? "" : filter.orderdDaysTab,
        orderStatus: filter.selectedFilter,
        warehouseId: filter.selectedWarehouseId,
        ordermanagerId: ordermanagerId,
        keyword: debouncedKeyword,
        // keyword: filter.debouncedKeyword,
        startDate: filter.orderStartDate,
        endDate: filter.orderEndDate,
        orderType: filter.orderType,
      };

      try {
        setLoading(true);
        const result = await fetchData(
          `order/allorders?page=${pagination.page}&limit=${limit}`,
          apiData,
        );

        if (result.status === "success") {
          dispatch(setData({ orders: result.data }));
          dispatch(setPagination({ pages: result.pages }));
          setLoading(false);

          if (result.orders) {
            setOrdersFilters(result.orders);
          }

          if (result.warehouses) {
            const formattedWarehouses = result.warehouses.map((w) => ({
              label: w.warehousename,
              value: w.warehouseId,
            }));
            setWarehouses(formattedWarehouses);
          }

          if (result.managers) {
            const formattedManagers = result.managers.map((m) => ({
              label: m.name,
              value: m.managerId,
            }));
            setManagers(formattedManagers);
          }
        }

        if (result.status === "failed") {
          dispatch(setData({ orders: [] }));
          setOrdersFilters([]);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [
      limit,
      filter.orderdDaysTab,
      filter.orderStartDate,
      filter.orderEndDate,
      filter.selectedFilter,
      filter.selectedWarehouseId,
      filter.selectedManagerID,
      debouncedKeyword,
      // filter.debouncedKeyword,
      managerId,
      pagination.page,
      dispatch,
      filter.orderType,
    ],
  );

  const getPurchaseOrders = useCallback(async () => {
    setAdjustmentOrderData([]);
    setTransferOrderData([]);
    dispatch(setData({ orders: [] }));

    if (limit === 1) return;

    if (
      filter.orderdDaysTab === "period" &&
      (filter.orderStartDate === "" || filter.orderEndDate === "")
    )
      return;

    const apiData = {
      managerId: parseInt(managerId),
      keyword: debouncedKeyword,
      // keyword: filter.debouncedKeyword,
      warehouseId: filter.selectedWarehouseId,
      day: filter.orderdDaysTab === "period" ? "" : filter.orderdDaysTab,
      orderStartDate: filter.orderStartDate,
      orderEndDate: filter.orderEndDate,
      orderStatus: filter.selectedFilter,
      inventorymanagerId: filter.selectedManagerID,
    };
    try {
      setLoading(true);
      const result = await fetchData(
        `inventory/allPurchase?page=${pagination.page}&limit=${limit}`,
        apiData,
      );
      if (result.status === "success") {
        setLoading(false);
        dispatch(setPagination({ pages: result.pages }));
        setPurchaseOrderData(result.data);
        setPurchaseFilters(result.orders);
        if (result.warehouses) {
          const formattedWarehouses = result.warehouses.map((w) => ({
            label: w.warehousename,
            value: w.warehouseId,
          }));
          setWarehouses(formattedWarehouses);
        }
        if (result.managers) {
          const formattedManagers = result.managers.map((m) => ({
            label: m.name,
            value: m.managerId,
          }));
          setManagers(formattedManagers);
        }
      }
      if (result.status === "failed") {
        dispatch(setData({ orders: [] }));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [
    limit,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    debouncedKeyword,
    // filter.debouncedKeyword,
    filter.selectedWarehouseId,
    filter.selectedFilter,
    filter.selectedManagerID,
    managerId,
    pagination.page,
    dispatch,
  ]);

  const getAdjustmentOrders = useCallback(async () => {
    setPurchaseOrderData([]);
    setTransferOrderData([]);
    dispatch(setData({ orders: [] }));

    if (limit === 1) return;

    if (
      filter.orderdDaysTab === "period" &&
      (filter.orderStartDate === "" || filter.orderEndDate === "")
    )
      return;

    const apiData = {
      managerId: parseInt(managerId),
    };
    try {
      setLoading(true);
      const result = await fetchData(
        `inventory/allAdjustment?page=${pagination.page}&limit=${limit}`,
        apiData,
      );
      if (result.status === "success") {
        setLoading(false);
        dispatch(setPagination({ pages: result.pages }));
        setAdjustmentOrderData(result.data);
        setAdjustmentFilters(result.orders);
      }
      if (result.status === "failed") {
        setLoading(false);
        dispatch(setData({ orders: [] }));
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [
    limit,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    managerId,
    pagination.page,
    dispatch,
  ]);

  const getTransferOrders = useCallback(async () => {
    setPurchaseOrderData([]);
    setAdjustmentOrderData([]);
    dispatch(setData({ orders: [] }));

    if (limit === 1) return;

    if (
      filter.orderdDaysTab === "period" &&
      (filter.orderStartDate === "" || filter.orderEndDate === "")
    )
      return;

    const apiData = {
      managerId: parseInt(managerId),
      // keyword: filter.debouncedKeyword,
      keyword: debouncedKeyword,
      fromwarehouse: filter.fromWarehouse,
      towarehouse: filter.toWarehouse,
      day: filter.orderdDaysTab === "period" ? "" : filter.orderdDaysTab,
      orderStartDate: filter.orderStartDate,
      orderEndDate: filter.orderEndDate,
      orderStatus: filter.selectedFilter,
      inventorymanagerId: filter.selectedManagerID,
    };
    try {
      setLoading(true);
      const result = await fetchData(
        `inventory/stocktransfers?page=${pagination.page}&limit=${limit}`,
        apiData,
      );
      if (result.status === "success") {
        setLoading(false);
        dispatch(setPagination({ pages: result.pages }));
        setTransferOrderData(result.data);
        setTransferFilters(result.orders);
        if (result.warehouses) {
          const formattedWarehouses = result.warehouses.map((w) => ({
            label: w.warehousename,
            value: w.warehouseId,
          }));
          setWarehouses(formattedWarehouses);
        }
        if (result.managers) {
          const formattedManagers = result.managers.map((m) => ({
            label: m.name,
            value: m.managerId,
          }));
          setManagers(formattedManagers);
        }
      }
      if (result.status === "failed") {
        dispatch(setData({ orders: [] }));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [
    limit,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    debouncedKeyword,
    // filter.debouncedKeyword,
    filter.fromWarehouse,
    filter.toWarehouse,
    filter.selectedFilter,
    filter.selectedManagerID,
    managerId,
    pagination.page,
    dispatch,
  ]);

  const getProductionAndSaleOrders = useCallback(
    async (id) => {
      setPurchaseOrderData([]);
      setAdjustmentOrderData([]);
      setTransferOrderData([]);
      dispatch(setData({ orders: [] }));

      const ordermanagerId = id ? id : filter.selectedManagerID;

      if (
        filter.orderdDaysTab === "period" &&
        (filter.orderStartDate === "" || filter.orderEndDate === "")
      )
        return;

      const apiData = {
        managerId: parseInt(managerId),
        day: filter.orderdDaysTab === "period" ? "" : filter.orderdDaysTab,
        voucherStatus: filter.selectedFilter,
        warehouseId: filter.selectedWarehouseId,
        ordermanagerId: ordermanagerId,
        keyword: debouncedKeyword,
        // keyword: filter.debouncedKeyword,
        startDate: filter.orderStartDate,
        endDate: filter.orderEndDate,
        voucherType: filter.orderType,
      };

      try {
        setLoading(true);
        const result = await fetchData(
          `order/allProdAndSalesVoucher?page=${pagination.page}&limit=${limit}`,
          apiData,
        );

        if (result.status === "success") {
          dispatch(setData({ orders: result.data }));
          dispatch(setPagination({ pages: result.pages }));

          setProductionAndSaleOrderData(result.data);
          setLoading(false);

          if (result.vouchers) {
            setProductionAndSaleFilters(result.vouchers);
          }

          if (result.warehouses) {
            const formattedWarehouses = result.warehouses.map((w) => ({
              label: w.warehousename,
              value: w.warehouseId,
            }));
            setWarehouses(formattedWarehouses);
          }

          if (result.managers) {
            const formattedManagers = result.managers.map((m) => ({
              label: m.name,
              value: m.managerId,
            }));
            setManagers(formattedManagers);
          }
        }

        if (result.status === "failed") {
          dispatch(setData({ orders: [] }));
          setProductionAndSaleFilters([]);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [
      limit,
      filter.orderdDaysTab,
      filter.orderStartDate,
      filter.orderEndDate,
      filter.selectedFilter,
      filter.selectedWarehouseId,
      filter.selectedManagerID,
      debouncedKeyword,
      // filter.debouncedKeyword,
      managerId,
      pagination.page,
      dispatch,
      filter.orderType,
    ],
  );

  useEffect(() => {
    const storedWarehouse = JSON.parse(localStorage.getItem("warehouse"));

    if (!managerId || !designation) return;

    // const isSuperAdmin = designation.includes("superadmin");

    const socketData = {
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: storedWarehouse,
    };

    SocketConnected(socketData);

    const handleProAndSaleAllOrderData = (updatedOrders) => {
      const newOrder = updatedOrders?.allPsVoucher?.data?.[0];

      if (newOrder) {
        setProductionAndSaleOrderData((prev) => {
          const filtered = prev.filter(
            (item) => item.voucherId !== newOrder.voucherId,
          );

          return [newOrder, ...filtered];
        });
      }

      // if (updatedOrders?.allPsVoucher?.vouchers) {
      //   setProductionAndSaleFilters(updatedOrders.allPsVoucher.vouchers);
      // }
    };

    socket.on("allVoucher", handleProAndSaleAllOrderData);

    return () => {
      socket.off("allVoucher", handleProAndSaleAllOrderData);
    };
  }, [designation, designations, managerId]);

  const getOrders = useCallback(
    (tab) => {
      switch (tab) {
        case "Order":
          getSaleOrders();
          break;
        case "Purchase":
          getPurchaseOrders();
          break;
        case "Adjustment":
          getAdjustmentOrders();
          break;
        case "Transfer":
          getTransferOrders();
          break;
        case "Production & Sale":
          getProductionAndSaleOrders();
          break;
        default:
          break;
      }
    },
    [
      getAdjustmentOrders,
      getPurchaseOrders,
      getSaleOrders,
      getTransferOrders,
      getProductionAndSaleOrders,
    ],
  );

  useEffect(() => {
    if (limit === 1) return;

    getOrders(filter.voucherTab);
  }, [
    reFetch,
    limit,
    getOrders,
    filter.voucherTab,
    filter.orderdDaysTab,
    filter.orderStartDate,
    filter.orderEndDate,
    filter.selectedFilter,
    filter.selectedWarehouseId,
    filter.selectedManagerID,
    filter.fromWarehouse,
    filter.toWarehouse,
    filter.selectedYear,
    debouncedKeyword,
  ]);

  useEffect(() => {
    SocketConnected({
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: JSON.parse(localStorage.getItem("warehouse")),
    });
  }, [designation, managerId]);

  const handleDayChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";

    dispatch(setFilter({ orderdDaysTab: newDayTab }));

    if (newDayTab !== "period") {
      setOrdersFilters([]);
      dispatch(setPagination({ pages: [] }));
      dispatch(setFilter({ orderStartDate: "" }));
      dispatch(setFilter({ orderEndDate: "" }));
    }
  };

  const handleVoucherChange = (voucherOptions, v) => {
    const selectedFilter = voucherOptions.find((item) => item === v);
    dispatch(setFilter({ voucherTab: selectedFilter }));
  };

  const handleMeChange = async (m, v) => {
    const selectedFilter = m.find((item) => item === v);
    dispatch(setFilter({ meTab: selectedFilter }));
    if (v === "Me") {
      await getSaleOrders(Number(managerId));
    }
    if (v === "All") {
      await getSaleOrders();
    }
  };

  const resetAllStates = () => {
    dispatch(setPagination({ page: 1 }));
    dispatch(setPagination({ pages: 1 }));
    dispatch(setFilter({ selectedWarehouseId: "" }));
    dispatch(setFilter({ selectedManagerID: "" }));
    dispatch(setFilter({ orderdDaysTab: "today" }));
    dispatch(setFilter({ orderStartDate: "" }));
    dispatch(setFilter({ orderEndDate: "" }));
    dispatch(setFilter({ keyword: "" }));
    // dispatch(setFilter({ debouncedKeyword: "" }));
    dispatch(setFilter({ selectedFilter: "All" }));
    dispatch(setFilter({ fromWarehouse: "" }));
    dispatch(setFilter({ toWarehouse: "" }));
    dispatch(setFilter({ meTab: "All" }));
    dispatch(setUi({ isSearchBarOpen: false }));
    dispatch(setFilter({ orderType: "All" }));

    // dispatch(setData({ orders: [] }));

    // setPurchaseOrderData([]);
    // setPurchaseFilters([]);
    // setAdjustmentOrderData([]);
    // setAdjustmentFilters([]);
    // setTransferOrderData([]);
    // setTransferFilters([]);
    // setWarehouses([]);
    // setManagers([]);
    setLoading(false);
    setReFetch((prev) => !prev);
    console.log(filter.selectedYear);
  };

  const SaleOrderTypeData = [
    {
      label: "All",
      value: "All",
    },
    // {
    //   label: "Offine",
    //   value: "offline",
    // },
    // {
    //   label: "Online",
    //   value: "online",
    // },
    {
      label: "Master Order",
      value: "Master Order",
    },
    {
      label: "Direct Collect",
      value: "Direct Collect",
    },
  ];

  const orderStatusData = [
    {
      status: "All",
      label: "All",
      count: ordersFilters[0]?.count || 0,
      allCount: ordersFilters[0]?.prevCount || 0,
      amount: ordersFilters[0]?.amount || 0,
    },
    {
      status: "New Order",
      label: "New Order",
      count: ordersFilters[1]?.count || 0,
      allCount: ordersFilters[1]?.prevCount || 0,
      amount: ordersFilters[1]?.amount || 0,
    },
    {
      status: "Cancelled",
      label: "Cancelled",
      count: ordersFilters[2]?.count || 0,
      allCount: ordersFilters[2]?.prevCount || 0,
      amount: ordersFilters[2]?.amount || 0,
    },
    {
      status: "In Progress",
      label: "In Progress",
      count: ordersFilters[3]?.count || 0,
      allCount: ordersFilters[3]?.prevCount || 0,
      amount: ordersFilters[3]?.amount || 0,
    },
    {
      status: "Payment Pending",
      label: "Payment Pending",
      count: ordersFilters[4]?.count || 0,
      allCount: ordersFilters[4]?.prevCount || 0,
      amount: ordersFilters[4]?.amount || 0,
    },
    {
      status: "Payment Under Verification",
      label: "Payment Under Verification",
      count: ordersFilters[5]?.count || 0,
      allCount: ordersFilters[5]?.prevCount || 0,
      amount: ordersFilters[5]?.amount || 0,
    },
    {
      status: "Packing In Progress",
      label: "Packing In Progress",
      count: ordersFilters[6]?.count || 0,
      allCount: ordersFilters[6]?.prevCount || 0,
      amount: ordersFilters[6]?.amount || 0,
    },
    {
      status: "Dispatched Pending",
      label: "Dispatched Pending",
      count: ordersFilters[7]?.count || 0,
      allCount: ordersFilters[7]?.prevCount || 0,
      amount: ordersFilters[7]?.amount || 0,
    },
    {
      status: "Dispatched",
      label: "Dispatched",
      count: ordersFilters[8]?.count || 0,
      allCount: ordersFilters[8]?.prevCount || 0,
      amount: ordersFilters[8]?.amount || 0,
    },
    {
      status: "Delivery Pending",
      label: "Delivery Pending",
      count: ordersFilters[9]?.count || 0,
      allCount: ordersFilters[9]?.prevCount || 0,
      amount: ordersFilters[9]?.amount || 0,
    },
    {
      status: "Completed",
      label: "Completed",
      count: ordersFilters[10]?.count || 0,
      allCount: ordersFilters[10]?.prevCount || 0,
      amount: ordersFilters[10]?.amount || 0,
    },
  ];

  const purchaseStatusData = [
    {
      status: "All",
      count: purchaseFilters[0]?.count || 0,
    },
    {
      status: "draft",
      count: purchaseFilters[1]?.count || 0,
    },
    {
      status: "success",
      count: purchaseFilters[2]?.count || 0,
    },
  ];

  const adjustmentStatusData = [
    {
      status: "All",
      count: adjustmentFilters[0]?.count + adjustmentFilters[1]?.count || 0,
    },
    {
      status: "draft",
      count: adjustmentFilters[0]?.count || 0,
    },
    {
      status: "success",
      count: adjustmentFilters[1]?.count || 0,
    },
  ];

  const transferStatusData = [
    {
      status: "All",
      count: transferFilters[0]?.count || 0,
    },
    {
      status: "draft",
      count: transferFilters[1]?.count || 0,
    },
    {
      status: "New Order",
      count: transferFilters[2]?.count || 0,
    },
    {
      status: "In Progress",
      count: transferFilters[3]?.count || 0,
    },
    {
      status: "Completed",
      count: transferFilters[4]?.count || 0,
    },
  ];

  const placeholder = [
    {
      status: "All",
      count: 0,
    },
    {
      status: "Failed",
      count: 0,
    },
    {
      status: "Success",
      count: 0,
    },
  ];

  const placeholderProductionAndSale = [
    {
      status: "All",
      label: "All",
      count: productionAndSaleFilters[0]?.count || 0,
      allCount: productionAndSaleFilters[0]?.prevCount || 0,
      amount: productionAndSaleFilters[0]?.amount || 0,
    },
    {
      status: "New Order",
      label: "New Order",
      count: productionAndSaleFilters[1]?.count || 0,
      allCount: productionAndSaleFilters[1]?.prevCount || 0,
      amount: productionAndSaleFilters[1]?.amount || 0,
    },
    {
      status: "Cancelled",
      label: "Cancelled",
      count: productionAndSaleFilters[2]?.count || 0,
      allCount: productionAndSaleFilters[2]?.prevCount || 0,
      amount: productionAndSaleFilters[2]?.amount || 0,
    },
    {
      status: "In Production",
      label: "In Production",
      count: productionAndSaleFilters[3]?.count || 0,
      allCount: productionAndSaleFilters[3]?.prevCount || 0,
      amount: productionAndSaleFilters[3]?.amount || 0,
    },
    {
      status: "Payment Pending",
      label: "Payment Pending",
      count: productionAndSaleFilters[4]?.count || 0,
      allCount: productionAndSaleFilters[4]?.prevCount || 0,
      amount: productionAndSaleFilters[4]?.amount || 0,
    },
    {
      status: "Payment Under Verification",
      label: "Payment Under Verification",
      count: productionAndSaleFilters[5]?.count || 0,
      allCount: productionAndSaleFilters[5]?.prevCount || 0,
      amount: productionAndSaleFilters[5]?.amount || 0,
    },
    {
      status: "Ready For Dispatch",
      label: "Ready For Dispatch",
      count: productionAndSaleFilters[6]?.count || 0,
      allCount: productionAndSaleFilters[6]?.prevCount || 0,
      amount: productionAndSaleFilters[6]?.amount || 0,
    },
    {
      status: "Dispatched",
      label: "Dispatched",
      count: productionAndSaleFilters[7]?.count || 0,
      allCount: productionAndSaleFilters[7]?.prevCount || 0,
      amount: productionAndSaleFilters[7]?.amount || 0,
    },
    {
      status: "Delivery Pending",
      label: "Delivery Pending",
      count: productionAndSaleFilters[8]?.count || 0,
      allCount: productionAndSaleFilters[8]?.prevCount || 0,
      amount: productionAndSaleFilters[8]?.amount || 0,
    },
    {
      status: "Completed",
      label: "Completed",
      count: productionAndSaleFilters[9]?.count || 0,
      allCount: productionAndSaleFilters[9]?.prevCount || 0,
      amount: productionAndSaleFilters[9]?.amount || 0,
    },
  ];

  const designationOptionsMap = useMemo(
    () => ({
      inventorymanager: orderTypeData,
      superadmin: orderTypeData,
      ordermanager: ["Order", "Collection", "Production & Sale"],
      default: ["Order"],
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const getAllowedOrderTypes = useCallback(
    (designations) => {
      if (!designations || designations.length === 0) {
        return designationOptionsMap.default;
      }

      const allowedTypes = new Set(designationOptionsMap.default);

      designations.forEach((designation) => {
        if (designationOptionsMap[designation]) {
          designationOptionsMap[designation].forEach((type) =>
            allowedTypes.add(type),
          );
        }
      });

      return Array.from(allowedTypes);
    },
    [designationOptionsMap],
  );

  const voucherOptions = useMemo(() => {
    return getAllowedOrderTypes(designations);
  }, [designations, getAllowedOrderTypes]);

  const isSuperAdmin = designations.includes("superadmin");

  const getOrderRoute = (orderType) => {
    const type = orderType?.toLowerCase();

    if (type === "offline" || type === "online") {
      return "saleorder";
    }

    if (type === "direct collect") {
      return "directcollect";
    }

    if (type === "master order") {
      return "masterorder";
    }

    return "saleorder";
  };

  return (
    <div
      className={styles.order}
      style={mode ? { backgroundColor: "#2C2E33", border: "none" } : {}}
    >
      <div className={styles.order_top}>
        <div className={styles.order_top_left}>
          <TopTabBar text={filter.voucherTab} />
        </div>
        <div className={styles.order_right}>
          <div>
            <SlidingFilter2
              itemList={daysData.map((item) => item.label)}
              setFilter={handleDayChange}
              selectedItem={
                daysData.find((item) => item.value === filter.orderdDaysTab)
                  ?.label
              }
            />
          </div>

          {filter.orderdDaysTab === "period" && (
            <>
              <div>
                <InputTypedate
                  text={"From"}
                  value={filter.orderStartDate}
                  max={filter.orderEndDate}
                  onChange={(e) => {
                    dispatch(setFilter({ orderStartDate: e.target.value }));
                    if (filter.orderdDaysTab !== "period") {
                      dispatch(setFilter({ orderdDaysTab: "" }));
                    }
                    dispatch(setFilter({ selectedFilter: "" }));
                  }}
                />
              </div>
              {filter.orderStartDate !== "" && (
                <div>
                  <InputTypedate
                    text={"To"}
                    value={filter.orderEndDate}
                    min={filter.orderStartDate}
                    onChange={(e) => {
                      dispatch(setFilter({ orderEndDate: e.target.value }));
                      if (filter.orderdDaysTab !== "period") {
                        dispatch(setFilter({ orderdDaysTab: "" }));
                      }
                      dispatch(setFilter({ selectedFilter: "" }));
                    }}
                  />
                </div>
              )}
            </>
          )}

          {isSuperAdmin && (
            <DropDown
              label={"F.Y."}
              listLabel={"2025-2026"}
              options={yearData}
              onSelect={(option) =>
                dispatch(setFilter({ selectedYear: option.label }))
              }
              onReject={() => dispatch(setFilter({ selectedYear: null }))}
            />
          )}

          <div>
            <Button
              buttonIcon={<DispatchReloadIcon />}
              buttonBgColor={"#000000"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={resetAllStates}
            />
          </div>
          <div>
            <Button
              buttonIcon={<CreateVoucherIcon />}
              buttonText={"Create"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={() => {
                navigate("/orders/order/saleorder");
              }}
            />
          </div>
          <Pagination2
            mode={mode}
            currentPage={pagination.page}
            setCurrentPage={(newPage) =>
              dispatch(setPagination({ page: newPage }))
            }
            totalPages={pagination.pages}
          />
        </div>
      </div>

      <div>
        <div
          className={styles.order_filters}
          style={
            mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
          }
        >
          <>
            {filter.voucherTab === "Order" && (
              <OrderFilters
                mode={mode}
                headerData={orderStatusData}
                selectedFilter={filter.selectedFilter}
                handleClick={(s) => {
                  dispatch(setFilter({ selectedFilter: s }));
                  dispatch(setPagination({ page: 1 }));
                }}
                getData={getSaleOrders}
                type={"order"}
              />
            )}
            {filter.voucherTab === "Collection" && (
              <OrderFilters mode={mode} headerData={placeholder} />
            )}
            {filter.voucherTab === "Purchase" && (
              <OrderFilters
                mode={mode}
                headerData={purchaseStatusData}
                selectedFilter={filter.selectedFilter}
                handleClick={(s) => {
                  dispatch(setFilter({ selectedFilter: s }));
                  dispatch(setPagination({ page: 1 }));
                }}
                getData={getPurchaseOrders}
              />
            )}
            {filter.voucherTab === "Adjustment" && (
              <OrderFilters
                mode={mode}
                headerData={adjustmentStatusData}
                selectedFilter={filter.selectedFilter}
                handleClick={(s) => {
                  dispatch(setFilter({ selectedFilter: s }));
                  dispatch(setPagination({ page: 1 }));
                }}
                getData={getAdjustmentOrders}
              />
            )}
            {filter.voucherTab === "Transfer" && (
              <OrderFilters
                mode={mode}
                headerData={transferStatusData}
                selectedFilter={filter.selectedFilter}
                handleClick={(s) => {
                  dispatch(setFilter({ selectedFilter: s }));
                  dispatch(setPagination({ page: 1 }));
                }}
                getData={getTransferOrders}
              />
            )}
            {filter.voucherTab === "Production" && (
              <OrderFilters mode={mode} headerData={placeholder} />
            )}
            {filter.voucherTab === "Production & Sale" && (
              <OrderFilters
                mode={mode}
                selectedFilter={filter.selectedFilter}
                headerData={placeholderProductionAndSale}
                handleClick={(s) => {
                  dispatch(setFilter({ selectedFilter: s }));
                  dispatch(setPagination({ page: 1 }));
                }}
                getData={getProductionAndSaleOrders}
                type={"Production & Sale"}
              />
            )}
            {filter.voucherTab === "Production & Transfer" && (
              <OrderFilters mode={mode} headerData={placeholder} />
            )}
          </>
        </div>
      </div>
      <div className={styles.order_data}>
        <div className={styles.order_data_filters}>
          <div>
            <ToggleSearchBar
              placeholder={"Search"}
              value={filter.keyword}
              onChange={(e) => {
                dispatch(setFilter({ keyword: e.target.value }));
                dispatch(setPagination({ page: 1 }));
              }}
              onToggle={(isExpanded) =>
                dispatch(setUi({ isSearchBarOpen: isExpanded }))
              }
            />
          </div>

          <div>
            {/* {!isSuperAdmin && filter.voucherTab === "Order" && (
              <SlidingFilter2
                itemList={MeOptions.map((item) => item)}
                setFilter={(v) => handleMeChange(MeOptions, v)}
                selectedItem={MeOptions.find((item) => item === filter.meTab)}
              />
            )} */}
            {ui.isSearchBarOpen ? (
              <DropDown
                label={"Type"}
                listLabel={
                  voucherOptions.find((item) => item === filter.voucherTab) ||
                  "Select"
                }
                options={voucherOptions.map((o) => ({ label: o, value: o }))}
                onSelect={(option) =>
                  dispatch(setFilter({ voucherTab: option.value }))
                }
                onReject={() => dispatch(setFilter({ voucherTab: "Order" }))}
              />
            ) : (
              <SlidingFilter2
                itemList={voucherOptions.map((item) => item)}
                setFilter={(v) => handleVoucherChange(voucherOptions, v)}
                selectedItem={voucherOptions.find(
                  (item) => item === filter.voucherTab,
                )}
              />
            )}

            {filter.voucherTab === "Order" && (
              <DropDown
                label={"Voucher Type"}
                listLabel={filter?.orderType || "All"}
                options={SaleOrderTypeData}
                onSelect={(option) =>
                  dispatch(setFilter({ orderType: option.value }))
                }
                onReject={() => dispatch(setFilter({ orderType: null }))}
              />
            )}

            {isSuperAdmin && (
              <>
                {filter.voucherTab === "Transfer" ? (
                  <>
                    <DropDown
                      label={"From"}
                      listLabel={"All"}
                      options={warehouses}
                      onSelect={(option) =>
                        dispatch(setFilter({ fromWarehouse: option.value }))
                      }
                      onReject={() =>
                        dispatch(setFilter({ fromWarehouse: null }))
                      }
                    />
                    <DropDown
                      label={"To"}
                      listLabel={"All"}
                      options={warehouses}
                      onSelect={(option) =>
                        dispatch(setFilter({ toWarehouse: option.value }))
                      }
                      onReject={() =>
                        dispatch(setFilter({ toWarehouse: null }))
                      }
                    />
                  </>
                ) : (
                  <DropDown
                    label={"Warehouse"}
                    listLabel={"All"}
                    options={warehouses}
                    onSelect={(option) =>
                      dispatch(setFilter({ selectedWarehouseId: option.value }))
                    }
                    onReject={() =>
                      dispatch(setFilter({ selectedWarehouseId: null }))
                    }
                  />
                )}
                <DropDown
                  label={"Manager"}
                  listLabel={"All"}
                  options={managers}
                  onSelect={(option) =>
                    dispatch(setFilter({ selectedManagerID: option.value }))
                  }
                  onReject={() =>
                    dispatch(setFilter({ selectedManagerID: null }))
                  }
                />
              </>
            )}
          </div>
        </div>

        <ul className={styles.order_data_list} ref={tableRef}>
          {filter.voucherTab === "Order" && (
            <VoucherList
              mode={mode}
              loading={loading}
              voucherTab={filter.voucherTab}
              headerData={orderHeader}
              orderData={data.orders}
              // handleClick={(d) =>
              //   navigate("/orders/order/saleorder?orderId=" + d.orderId)
              // }

              handleClick={(d) => {
                const route = getOrderRoute(d.orderType);

                // console.log("orderType:", d.orderType);
                // console.log("mapped route:", route);

                navigate(`/orders/order/${route}?orderId=${d.orderId}`);
              }}
            />
          )}

          {filter.voucherTab === "Purchase" && (
            <VoucherList
              mode={mode}
              loading={loading}
              voucherTab={filter.voucherTab}
              headerData={purchaseOrderHeader}
              orderData={purchaseOrderData}
              handleClick={(d) =>
                navigate(`/orders/order/purchase?orderId=${d.voucherNo}`)
              }
            />
          )}

          {filter.voucherTab === "Adjustment" && (
            <VoucherList
              mode={mode}
              loading={loading}
              voucherTab={filter.voucherTab}
              headerData={adjustmentOrderHeader}
              orderData={adjustmentOrderData}
              handleClick={(d) =>
                navigate("/orders/order/adjustment?orderId=" + d.voucherNo)
              }
            />
          )}

          {filter.voucherTab === "Transfer" && (
            <VoucherList
              mode={mode}
              loading={loading}
              voucherTab={filter.voucherTab}
              headerData={transferOrderHeader}
              orderData={transferOrderData}
              handleClick={(d) =>
                navigate("/orders/order/transfer?orderId=" + d.voucherNo)
              }
            />
          )}

          {filter.voucherTab === "Production & Sale" && (
            <VoucherList
              mode={mode}
              loading={loading}
              voucherTab={filter.voucherTab}
              headerData={productionAndSaleHeader}
              orderData={productionAndSaleOrderData}
              handleClick={(d) => {
                // console.log(d);
                // console.log("orderType:", d.voucherType);
                // console.log("orderId:", d.voucherId);

                navigate(
                  `/orders/order/productionAndSale?orderId=${d.voucherId}`,
                );
              }}
            />
          )}
        </ul>
      </div>
    </div>
  );
};

export default AllOrders;
